import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Hidden, Button } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
// import Grow from '@material-ui/core/Grow';
// import Slide from '@material-ui/core/Slide';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles(theme => ({
  name: {
    paddingTop: '2vh',
    color: '#404040',
    fontSize: 48,
    fontWeight: 700,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(',')
  },
  media: {
    maxWidth: 270,
    maxHeight: 284,
    width: '100%'
  },
  introduction: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    width: '35vw'
  },
  introduction_mdUp: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    width: '80vw'
  },
  career: {
    paddingTop: '3vh',
    marginBlockEnd: '0em',
    marginBlockStart: '0em',
    color: '#4e4e4e',
    fontSize: '1.5rem',
    fontWeight: 300
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
    >
      <Fade in={true} timeout={700}>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography className={classes.name} >Davi Baltar</Typography>
            <Hidden smDown>
              <Typography className={classes.career} style={{ width: '35vw' }}>Full Stack Developer</Typography>
              <Typography className={classes.introduction} >I'm a computing engineer with experience in front-end and back-end development for scalable web apps. I also work with reverse engineering and other areas of computing. Want to learn more about some of my projects? Check out the portfolio section and online resume.</Typography>
            </Hidden>
            <Hidden mdUp>
              <Typography className={classes.career} >Full Stack Developer</Typography>
              <Typography className={classes.introduction_mdUp} >I'm a computing engineer with experience in front-end and back-end development for scalable web apps. I also work with reverse engineering and other areas of computing. Want to learn more about some of my projects? Check out the portfolio section and online resume.</Typography>
            </Hidden>
            <Button
              variant="contained"
              href="/resume"
              style={{ marginTop: '4vh', color: "#FCFCFC", background: "#84a086" }}
              startIcon={<DescriptionIcon />}
            >
              View Resume
            </Button>
          </Grid>
          <Hidden smDown>
            <Grid item style={{ width: '35%' }}>
              <img alt="capa" className={classes.media} src="/images/capa-md-2.png" />
            </Grid>
          </Hidden>
        </Grid>
      </Fade>
      {/* <Hidden lgDown> 1. lgDown <br /> </Hidden>
      <Hidden lgUp> 2. lgUp <br /> </Hidden>
      <Hidden mdDown> 3. mdDown <br /> </Hidden>
      <Hidden mdUp> 4. mdUp <br /> </Hidden>
      <Hidden smDown> 5. smDown <br /> </Hidden>
      <Hidden smUp> 6. smUp <br /> </Hidden>
      <Hidden xlDown> 7. xlDown <br /> </Hidden>
      <Hidden mdUp> 8. mdUp <br /> </Hidden>
      <Hidden xlUp> 9. xlUp <br /> </Hidden>
      <Hidden xsDown> 10. xsDown <br /> </Hidden>
      <Hidden xsUp> 11. xsUp <br /> </Hidden> */}
    </div>
  );
};

export default Header;